/* global swal */
import React, { useEffect } from 'react';
import MainSlider from '../components/MainSlider';
import Testimonial from '../components/Testimonial';
import Newsletter from '../components/NewsLetter';
// import BlogsHome from '../components/BlogsHome'
import AboutUs from '../components/about-us/AboutUs';
import ServiceList from '../components/services/ServiceList';
import Philosophy from '../components/about-us/Philosophy';
import OurServices from '../components/services/OurServices';
import VetGallary from '../components/VetGallary';
import Swal from "sweetalert2";
import './sweetalert2-custom.css';

function Home() {
  useEffect(() => {
    initPopup();
  }, []);

  // Welcome popup
  // const initPopup = () => {
  //   if (!document.referrer.includes(window.location.host)) {
  //     setTimeout(() => {
  //     const content = document.createElement("div");
  //     content.style.textAlign = "center";
  //     content.style.whiteSpace = "pre-line";
  //     content.innerText =
  //       "Due to an emergency, Sunshine Animal Clinic is temporarily closed until further notice.\nPlease check back for updates regarding our reopening.\n\nSunshine Animal Clinic Management";

  //     swal({
  //       title: "Important Clinic Update",
  //       content: content,
  //       confirmButtonText: "OK",
  //       });
  //     }, 2000);
  //   }
  // };
  const initPopup = () => {
    setTimeout(() => {
      Swal.fire({
        title: "Important Clinic Update",
        html: `
          <div class="popup-content">
            <p>
              Dr. Patel has returned and the clinic is now operating at normal hours and capacity. 
            </p> 
            </p>            
          </div>
        `,
        confirmButtonText: "OK",
        buttonsStyling: false,
        customClass: {
          popup: "custom-swal-popup",
          title: "custom-swal-title",
          confirmButton: "custom-swal-btn",
        },
        allowOutsideClick: false,
        allowEscapeKey: true,
      });
    }, 2000);
  };

  return (
    <main>
      <MainSlider />
      <AboutUs />
      <VetGallary />
      <br></br>
      <br></br>
      <OurServices />
      <Philosophy />
      <ServiceList />
      <Testimonial />
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      {/* <BlogsHome/> */}
      <Newsletter />
    </main>
  );
}

export default Home;
